import { Hero, Images, Painting } from 'models/painting'

export async function getPaintings(): Promise<Painting[]> {
  const updatedPaintingList: Painting[] = []
  await fetch('api/get', {
    method: 'GET',
  }).then(async response => {
    const paintings = await response.json()

    for (let i = 0; i < paintings.length; i++) {
      const hero: Hero = {
        small: paintings[i].images.hero.small,
        large: paintings[i].images.hero.large,
      }
      const images: Images = {
        thumbnail: paintings[i].images.thumbnail,
        hero: hero,
        gallery: paintings[i].images.gallery,
      }
      const painting: Painting = {
        id: paintings[i].id,
        name: paintings[i].name,
        year: paintings[i].year,
        description: paintings[i].description,
        source: paintings[i].source,
        artist: paintings[i].artist,
        images: images,
        isPortrait: paintings[i].isPortrait,
      }
      updatedPaintingList.push(painting)
    }
  })

  return updatedPaintingList
}
